import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles<string, {}, Theme>((theme: Theme) => ({
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.std,
  },
  thead: {
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.colors.grayBorder,
  },
  line: {
    ...theme.fonts.caption,
    height: theme.height.regular,
    position: 'relative',
    borderBottom: {
      width: 1,
      style: 'solid',
      color: theme.colors.grayBorder,
    },
  },
  headCell: {
    ...theme.fonts.label,
    textAlign: 'left',
    padding: [[theme.marginBase, theme.marginBase * 2]],
  },
  cell: {
    ...theme.fonts.body,
    padding: [[theme.marginBase, theme.marginBase * 2]],
  },
}));

interface Props {
  data?: any[];
  columns: Array<{
    title: string;
    key: string | ((data: any) => React.ReactNode);
  }>;
}

export const SimpleTable = ({ data, columns }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <table className={classes.table}>
      <thead className={classes.thead}>
        <tr className={classes.line}>
          {columns.map(({ title }) => (
            <th key={title} className={classes.headCell}>
              {title}
            </th>
          ))}
        </tr>
      </thead>
      {data &&
        data.map((line) => (
          <tr className={classes.line} key={line.id}>
            {columns.map(({ title, key }) => (
              <td key={`${line.id}-${title}`} className={classes.cell}>
                {typeof key === 'function' ? key(line) : line[key]}
              </td>
            ))}
          </tr>
        ))}
    </table>
  );
};
